import { AbstractMoveValueOfArrayCommand } from "./AbstractMoveValueOfArrayCommand";

export class MoveValueOfArrayCommand<TSource, TValue> extends AbstractMoveValueOfArrayCommand<TSource, TValue> {
  constructor(private readonly _readArray: (s: TSource) => TValue[], from: number, to: number) {
    super(from, to);
  }

  protected readArray(source: TSource): TValue[] {
    return this._readArray(source);
  }
}
